import { __ } from '@wordpress/i18n';
import { generateClassDropdownItem } from './utils';

/**
 * Represents an array of spacing sizes with their corresponding values and labels.
 */
const sizes = [
  { value: '0', label: 'None (0px)' },
  { value: '10', label: 'XXS (10px)' },
  { value: '20', label: 'XS (20px)' },
  { value: '30', label: 'S (30px)' },
  { value: '40', label: 'M (40px)' },
  { value: '50', label: 'L (50px)' },
  { value: '60', label: 'XL (60px)' },
  { value: '80', label: 'XXL (80px)' },
  { value: '90', label: '3XL (90px)' },
  { value: '100', label: '4XL (100px)' },
  { value: '120', label: '5XL (120px)' },
];

/**
 * Represents all the constants used in the for the spacing selector component.
 */
const constants = {
  HELP_TEXT: __(
    "Select a spacing value (XS, S, M, L, XL) corresponding to the style guide's spacing options.",
    'b3rg',
  ),
  DEFAULT_OPTION: { value: '', label: __('Please choose an option.', 'b3rg') },
  SPACING_VALUES: {
    spacingTop: {
      desktop: {
        margin: sizes.map((item) => generateClassDropdownItem('e-mt', item)),
        padding: sizes.map((item) => generateClassDropdownItem('e-pt', item)),
      },
      mobile: {
        margin: sizes.map((item) => generateClassDropdownItem('e-mt-sm', item)),
        padding: sizes.map((item) =>
          generateClassDropdownItem('e-pt-sm', item),
        ),
      },
    },
    spacingBottom: {
      desktop: {
        margin: sizes.map((item) => generateClassDropdownItem('e-mb', item)),
        padding: sizes.map((item) => generateClassDropdownItem('e-pb', item)),
      },
      mobile: {
        margin: sizes.map((item) => generateClassDropdownItem('e-mb-sm', item)),
        padding: sizes.map((item) =>
          generateClassDropdownItem('e-pb-sm', item),
        ),
      },
    },
  },
};

export default constants;
